export const Logo = () => {
  return <>SSD</>
}
